'use es6';

import { DEFAULT_HEADER_QUERY_PARAM_VALUES, HeaderQueryParamNames, HeaderQueryParams, VALID_HEADER_QUERY_PARAM_VALUES } from '../constants/HeaderQueryParams';
import { findAndCorrectInvalidParamValues, makeParamsGetter } from './paramHelpers';
export const sanitizeHeaderParamValue = (param, val) => {
  switch (param) {
    case HeaderQueryParamNames.HEADER_DETAILS_SIDEBAR_OPEN:
      return val === 'true';

    default:
      return val;
  }
};
const applicaitonParamsGetter = makeParamsGetter(HeaderQueryParams, sanitizeHeaderParamValue, true);

const paramsWithDefaults = params => {
  for (const param in DEFAULT_HEADER_QUERY_PARAM_VALUES) {
    if (params[param] === undefined) {
      params[param] = DEFAULT_HEADER_QUERY_PARAM_VALUES[param];
    }
  }

  return params;
};

export const getHeaderParams = ({
  location
}) => paramsWithDefaults(applicaitonParamsGetter(location.search));
export const findAndCorrectInvalidPagesParamValues = query => findAndCorrectInvalidParamValues(query, HeaderQueryParams, VALID_HEADER_QUERY_PARAM_VALUES, DEFAULT_HEADER_QUERY_PARAM_VALUES);